<ng-container *ngIf="!environmentIsUsa">
  <app-product-form-de
    [produktFormData]="produktData"
    [produktTypenDatasource]="produktTypenDatasource"
  ></app-product-form-de>
</ng-container>
<ng-container *ngIf="environmentIsUsa">
  <app-product-form-us [produktFormData]="produktData"></app-product-form-us>
</ng-container>
